exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fts-standard-menu .standard-menu-toggle[data-v-7c68b8e4]{font-size:.75rem;color:var(--fts-gray-5)}.fts-standard-menu .standard-activity[data-v-7c68b8e4]{font-size:.875rem}.fts-standard-menu .standard-activity .standard-activity-icon[data-v-7c68b8e4]{margin-right:.575rem;color:var(--fts-gray-5)}", ""]);

// exports
